export default {"src":"/_next/static/media/time.be5d1f09.svg","height":34,"width":34};